module.exports = __webpack_public_path__ + "img/fond-les-triangles-constructeurs.68d91ae7.png";